module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/icons/bump-marketing-icon-f4b3b9d01de2c3b8a2ce99192f00765f.svg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/icons/bump-marketing-icon.svg
// module id = NnOg
// module chunks = 20 21